import React, { createContext, useState } from 'react';

import MeetFormatData from './MeetFormatData';

export const MeetFormatStateContext = createContext();

const MeetFormatContextProvider = ({ children }) => {
  const stateHook = useState(MeetFormatData.INITIAL_STATE);

  return (
    <MeetFormatStateContext.Provider value={stateHook}>
      {children}
    </MeetFormatStateContext.Provider>
  );
};

export default MeetFormatContextProvider;